module.exports = __webpack_public_path__ + "static/media/44-iveco-mercedes.6c8e65e2.jpg";